import { icoSellCarRoutes } from './ico-sell-car';

export const routes = Array.prototype.concat(icoSellCarRoutes);
